import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import { ResendCodeConfigState } from "./types";
import AsyncStorage from "@react-native-async-storage/async-storage";

export const initialValues = {
  expiresInSeconds: 0
};

export const useResendCodeConfigStore = create<ResendCodeConfigState>()(
  persist(
    (set, get) => ({
      ...initialValues,
      getExpiresInSeconds: () => get().expiresInSeconds,
      setExpiresInSeconds: (expiresInSeconds) => set({ expiresInSeconds }),
      reset: () => set({ ...initialValues })
    }),
    {
      name: "ResendCodeConfigStore",
      storage: createJSONStorage(() => AsyncStorage)
    }
  )
);
